import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index";
import RealEstate from "./pages/RealEstate";
import Mortgage from "./pages/Mortgage";
import Speaking from "./pages/Speaking";
import AcademyRedirect from "./pages/AcademyRedirect";
import Tools from "./pages/Tools";
import TechFounderSummit from "./pages/TechFounderSummit";
import VIPUpgrade from "./pages/VIPUpgrade";
import VIPThankYou from "./pages/VIPThankYou";
import ThankYou from "./pages/ThankYou";
import About from "./pages/About";
import NotFound from "./pages/NotFound";
import Day1 from "./pages/Day1";
import Day2 from "./pages/Day2";
import Day3 from "./pages/Day3";
import VIPDay4 from "./pages/VIPDay4";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import BlogAiAutomation2026 from "./pages/BlogAiAutomation2026";
import BlogAutomateRealEstateLeadQualification from "./pages/BlogAutomateRealEstateLeadQualification";

const queryClient = new QueryClient();

/** Routes + providers, router-agnostic so the prerenderer can reuse them. */
export const AppRoutes = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<About />} />
        <Route path="/real-estate" element={<RealEstate />} />
        <Route path="/mortgage" element={<Mortgage />} />
        <Route path="/speaking" element={<Speaking />} />
        <Route path="/academy" element={<AcademyRedirect />} />
        <Route path="/academy/tools" element={<Tools />} />
        <Route path="/tech-founder-summit" element={<TechFounderSummit />} />
        <Route path="/day-1" element={<Day1 />} />
        <Route path="/day-2" element={<Day2 />} />
        <Route path="/day-3" element={<Day3 />} />
        <Route path="/vip-day-4" element={<VIPDay4 />} />
        <Route path="/vip-upgrade" element={<VIPUpgrade />} />
        <Route path="/vip-thank-you" element={<VIPThankYou />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog/real-estate-ai-automation-2026" element={<BlogAiAutomation2026 />} />
        <Route path="/blog/automate-real-estate-lead-qualification" element={<BlogAutomateRealEstateLeadQualification />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </TooltipProvider>
  </QueryClientProvider>
);

const App = () => (
  <>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
    <Analytics />
  </>
);

export default App;
